// helix-exception: Helix has no semantic token for these hues (Figma needs-input orange, highlight yellow/amber, categorical teal/cyan); primitive ramps with the identical colour are used (F-11)
export type ClinicalSummaryCategory = 'Key' | 'Additional' | 'Excluded'

/** Background utility for the section header dot (apply with `size-[9px] rounded-xs`). */
export function categorySectionDotClass(category: ClinicalSummaryCategory): string {
  switch (category) {
    case 'Key':
      return 'bg-brand-300'
    case 'Additional':
      return 'bg-brand-200'
    case 'Excluded':
      return 'bg-border-error-subtle'
  }
}

/** Border, fill, and text utilities for phenotype chips (apply with rounded-full border). */
export function categoryChipClass(category: ClinicalSummaryCategory): string {
  switch (category) {
    case 'Key':
      return 'border-brand-300 bg-brand-100 dark:bg-gray-800 text-brand-950 dark:text-brand-400'
    case 'Additional':
      return 'border-brand-200 dark:border-brand-800 bg-background-brand-softer dark:bg-gray-800 text-brand-950 dark:text-brand-400'
    case 'Excluded':
      return 'border-border-error-subtle dark:border-error-700 bg-error-50 dark:bg-gray-900 text-text-fg-error-strong dark:text-error-100'
  }
}

/** A chip still on the order whose supporting text is no longer in the summary, whatever its category. */
export const orphanChipClass =
  'border-dashed border-border-orange bg-warning-50 dark:bg-gray-900 text-orange-900 dark:text-orange-200'
